import React, { Fragment, useEffect, useState } from 'react';
import {
  Button,
  TextField,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
} from '@material-ui/core';
import { Observer } from 'mobx-react';
import EditIcon from '@material-ui/icons/Edit';
import { Formik } from 'formik';
import axios from 'axios';
import { toJS } from 'mobx';
import ConfirmDialog from '../../dealMapper/common/ConfirmDialog';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, StyledForm, FormRow } from '../../styles/styles';

const AccountSettings = () => {
  return (
    <Observer
      render={() => {
        const { authStore, orgStore } = useRootStore();
        const [isLoading, setLoading] = useState(true);
        const [accountInfo, setAccountInfo] = useState(null);
        const [isEditing, setIsEditing] = useState(false);
        const [changes, setChanges] = useState(false);
        const [userRoles, setUserRoles] = useState([]);
        const { user } = authStore;
        const { userId } = orgStore;
        const { sub } = user;

        const getUserRoles = async () => {
          const { data } = await authStore.request.get(
            `${process.env.REACT_APP_API}/api/organization/user/${userId}`,
          );
          const { OrgRoles } = data[0];
          setUserRoles(OrgRoles);
        };

        const checkForChanges = async () => {
          if (sub) {
            const path = `${process.env.REACT_APP_API}/api/update-email/${sub}`;
            try {
              const { data } = await axios.get(path);
              setChanges(Boolean(data));
            } catch (error) {
              console.log(error);
            }
          }
        };
        const getAccountInfo = async () => {
          const { data } = await authStore.request.get(
            `${process.env.REACT_APP_API}/api/user`,
          );

          setAccountInfo(data);
        };

        useEffect(() => {
          const initialActions = async () => {
            await Promise.all([getAccountInfo()]);
          };
          initialActions();
        }, []);

        useEffect(() => {
          if (accountInfo) {
            checkForChanges();
            getUserRoles();
            setLoading(false);
          }
        }, [accountInfo]);

        const submitRequest = async newEmail => {
          try {
            const { data } = await authStore.request.post(
              `${process.env.REACT_APP_API}/api/email-change`,
              {
                oldEmail: accountInfo.Email,
                newEmail,
                authId: sub,
              },
            );
            const subject = 'Email Change';
            authStore.request.post(
              `${process.env.REACT_APP_API}/api/email-template`,
              {
                subject,
                to: accountInfo.Email,
                templateId: 'd-f1a7e7608e98415f87e93df637652957',
                dynamicTemplateData: {
                  first_name: accountInfo.Name.split(' ')[0],
                  new_email: newEmail,
                  weblink: `${
                    process.env.REACT_APP_DOMAIN
                  }/email-confirmation?status=reject#${`${data.RejectHash}|${
                    sub.split('|')[sub.split('|').length - 1]
                  }`}`,
                },
              },
            );

            authStore.request.post(
              `${process.env.REACT_APP_API}/api/email-template`,
              {
                subject,
                to: newEmail,
                templateId: 'd-cbdf9e68d3af45e9b4cd77c624926cab',
                dynamicTemplateData: {
                  first_name: accountInfo.Name.split(' ')[0],
                  weblink: `${
                    process.env.REACT_APP_DOMAIN
                  }/email-confirmation?status=confirm#${`${data.ConfirmHash}|${
                    sub.split('|')[sub.split('|').length - 1]
                  }`}`,
                },
              },
            );
            setChanges(true);
          } catch (e) {
            console.log(e);
          }
        };

        const updateUserName = async name => {
          try {
            await authStore.request.post(
              `${process.env.REACT_APP_API}/api/manage-profile`,
              {
                userId: sub,
                name,
              },
            );

            const notificationPref = JSON.stringify(
              accountInfo.NotificationPref,
            );
            await authStore.request.post(
              `${process.env.REACT_APP_API}/api/user`,
              {
                name,
                notificationPref,
              },
            );
            getAccountInfo();
          } catch (err) {
            console.log(err);
          }
        };

        // TODO: REFACTOR THIS MESS

        if (isLoading) return <Spinner />;
        return (
          <div
            style={{
              alignItems: 'flex-start',
              width: '100%',
              height: 'inherit',
            }}
          >
            <Formik
              initialValues={{
                Email: accountInfo.Email || '',
                confirmEmail: '',
                Name: accountInfo.Name || '',
              }}
              onSubmit={async (values, actions) => {
                const { Email, Name } = values;
                submitRequest(Email);
                actions.setSubmitting(false);
              }}
              render={({
                handleBlur,
                handleChange,
                errors,
                handleSubmit,
                values,
                isSubmitting,
              }) => (
                <FlexDiv style={{ alignItems: 'flex-start' }}>
                  {changes && (
                    <div style={{ color: '#4aa54e', fontSize: '12px' }}>
                      * An email change is in progress awaiting verification
                    </div>
                  )}
                  <StyledForm onSubmit={handleSubmit}>
                    {!isEditing && (
                      <List
                        style={{
                          marginLeft: '20px',
                          paddingBottom: '0px',
                          width: 'inherit',
                        }}
                      >
                        <ListItem>
                          <ListItemText
                            primary="Email"
                            secondary={accountInfo.Email}
                            primaryTypographyProps={{ variant: 'h6' }}
                            secondaryTypographyProps={{ variant: 'h6' }}
                          />
                          <ConfirmDialog
                            title="Update Email Address"
                            content={() => (
                              <div>
                                <p>
                                  By changing your email, all other logins
                                  associated with this account will be dropped
                                  for security purposes. This is only relevant
                                  if you use more than one form of
                                  authentication (e.g., Login with Xero + Login
                                  with username and password)
                                </p>
                                <p>
                                  This change will go into effect only after the
                                  new email address is confirmed. Do you wish to
                                  proceed?
                                </p>
                              </div>
                            )}
                            actions={({ handleClose }) => (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-around',
                                  flex: 1,
                                }}
                              >
                                <Button
                                  color="primary"
                                  variant="contained"
                                  onClick={() => {
                                    setIsEditing(true);
                                    handleClose();
                                  }}
                                >
                                  Yes
                                </Button>
                                <Button
                                  color="secondary"
                                  variant="contained"
                                  onClick={() => {
                                    handleClose();
                                  }}
                                >
                                  No
                                </Button>
                              </div>
                            )}
                          >
                            {({ handleOpen }) => {
                              return (
                                <IconButton onClick={() => handleOpen()}>
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              );
                            }}
                          </ConfirmDialog>
                        </ListItem>
                      </List>
                    )}
                    {isEditing && (
                      <div style={{ margin: '20px 12px' }}>
                        <TextField
                          name="Email"
                          label="Email"
                          variant={isEditing ? 'outlined' : 'standard'}
                          fullWidth
                          disabled={!isEditing}
                          value={values.Email}
                          margin="normal"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.Email && <div>{errors.Email}</div>}
                        <TextField
                          name="confirmEmail"
                          label="Confirm Email"
                          variant="outlined"
                          fullWidth
                          value={values.confirmEmail}
                          margin="normal"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={values.confirmEmail !== values.Email}
                        />
                      </div>
                    )}
                    <div style={{ display: 'flex', margin: '0 12px' }}>
                      {isEditing && (
                        <>
                          <Button
                            color="primary"
                            variant="contained"
                            type="submit"
                            size="large"
                            disabled={values.confirmEmail !== values.Email}
                            style={{ margin: '1.2rem 0.6rem 0 0' }}
                          >
                            Submit
                          </Button>

                          <Button
                            color="secondary"
                            variant="outlined"
                            size="large"
                            style={{ marginTop: '1.2rem' }}
                            onClick={() => setIsEditing(false)}
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                    </div>
                  </StyledForm>
                </FlexDiv>
              )}
            />
            <Formik
              initialValues={{
                Name: accountInfo.Name || '',
                editing: false,
              }}
              onSubmit={async (values, actions) => {
                const { Name } = values;
                // submitRequest(Email);
                updateUserName(Name);
                actions.setSubmitting(false);
                actions.setFieldValue('editing', false);
              }}
              render={({
                handleBlur,
                handleChange,
                errors,
                handleSubmit,
                values,
                isSubmitting,
                setFieldValue,
              }) => (
                <FlexDiv style={{ alignItems: 'flex-start' }}>
                  <StyledForm onSubmit={handleSubmit}>
                    <List
                      style={{
                        marginLeft: '20px',
                        paddingTop: '0px',
                        paddingBottom: '0px',
                        width: 'inherit',
                      }}
                    >
                      <ListItem>
                        <ListItemText
                          primary="Name"
                          secondary={accountInfo.Name}
                          primaryTypographyProps={{ variant: 'h6' }}
                          secondaryTypographyProps={{ variant: 'h6' }}
                        />
                        {!values.editing && (
                          <IconButton
                            onClick={() => setFieldValue('editing', true)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        )}
                      </ListItem>
                      {values.editing && (
                        <Fragment>
                          <TextField
                            name="Name"
                            label="Name"
                            variant="outlined"
                            fullWidth
                            value={values.Name}
                            margin="normal"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <div style={{ display: 'flex', margin: '0 12px' }}>
                            <Button
                              color="primary"
                              variant="contained"
                              type="submit"
                              size="large"
                              disabled={isSubmitting}
                              style={{ margin: '1.2rem 0.6rem 0 0' }}
                            >
                              Submit
                            </Button>

                            <Button
                              color="secondary"
                              variant="outlined"
                              size="large"
                              style={{ marginTop: '1.2rem' }}
                              onClick={() => setFieldValue('editing', false)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Fragment>
                      )}

                      {userRoles.length > 0 && (
                        <ListItem>
                          <ListItemText
                            primary={`Organization ${
                              userRoles.length === 1 ? 'Role' : 'Roles'
                            }`}
                            secondary={userRoles.map((role, index) => (
                              <span key={role.RoleId}>
                                {role.RoleName}
                                {index !== userRoles.length - 1 && ', '}
                              </span>
                            ))}
                            primaryTypographyProps={{ variant: 'h6' }}
                            secondaryTypographyProps={{ variant: 'h6' }}
                          />
                        </ListItem>
                      )}
                    </List>
                  </StyledForm>
                </FlexDiv>
              )}
            />
          </div>
        );
      }}
    />
  );
};

export default AccountSettings;
